import {EventBus} from "./event-bus";
import VueFlatPickr from 'vue-flatpickr-component';
import VueSweetalert2 from "vue-sweetalert2";

window.Vue = require('vue');
window.axios = require('axios');

Vue.component('map-component', require('./components/MapComponent').default);
Vue.component('reservation-form-component', require('./components/ReservationFormComponent').default);
Vue.component('reservation-map-component', require('./components/ReservationMapComponent').default);

Vue.use(VueFlatPickr);
Vue.use(VueSweetalert2);

const app = new Vue({
    el: '#app',
});

window.initMap = function() {
    EventBus.$emit('maps-loaded');
};

EventBus.$on('registerLatLng', (lat, long) => {
    window.registerLatLong(lat, long);
});
